export enum SiteTimingStatuses {
  CLOSED = 'closed',
  OPEN = 'open',
  ALL_DAY = '24_hours'
}
